// Ustawienie "Numeruj uchwały od początku, w każdym nowym roku" dotyczy całego klienta (rid), a nie grupy,
// więc zapisujemy je tylko wtedy, gdy znamy jego stan z serwera i użytkownik go faktycznie zmienił.
// loadedValue inne niż boolean (null/undefined) oznacza stan niewczytany lub błąd odczytu.
export function shouldSaveResolutionBeginByYear(loadedValue, currentValue) {
    if (typeof loadedValue !== "boolean") {
        return false;
    }

    return currentValue !== loadedValue;
}
